<template>
  <section id="menu-left" class="menu-left-width pl-10 pr-4 box-border">
    <ul
      class="menu-list fixed font-semibold text-gray text-base leading-8"
      style="top: 180px"
    >
      <li
        class="my-4 pl-6 box-border border-l-2"
        :class="{ 'text-gray-92': active === 'account' }"
        :style="{
          'border-color': active === 'account' ? '#28395c' : 'transparent',
        }"
      >
        <router-link
          :to="{ name: 'AccountInfo' }"
          :class="{ 'text-gray-92': active === 'account' }"
          >アカウント情報</router-link
        >
      </li>
      <li
        class="my-4 pl-6 box-border border-l-2"
        :class="{ 'text-gray-92': active === 'password' }"
        :style="{
          'border-color': active === 'password' ? '#28395c' : 'transparent',
        }"
      >
        <router-link
          :to="{ name: 'AccountPassword' }"
          :class="{ 'text-gray-92': active === 'password' }"
          >パスワード変更</router-link
        >
      </li>
      <li class="my-4" style="width: 178px">
        <router-link
          :to="{ name: 'AccountSettings' }"
          class="flex h-8 box-border border-l-2 pl-6"
          :class="{ 'text-gray-92': active === 'settings' }"
          :style="{
            'border-color': active === 'settings' ? '#28395c' : 'transparent',
          }"
          >詳細設定</router-link
        >
        <ul
          class="menu-list mt-3 pl-10 text-sm text-gray-62"
          v-if="active === 'settings'"
        >
          <li
            class="font-light cursor-pointer leading-5 h-8"
            :class="{
              'text-gray-92 font-semibold':
                visibleSection === 'accountNotification',
            }"
            @click="$emit('go-to-section', 'accountNotification')"
          >
            通知設定
          </li>
          <li
            class="font-light cursor-pointer leading-5"
            :class="{
              'text-gray-92 font-semibold':
                visibleSection === 'accountMsgFuncAgreement',
            }"
            @click="$emit('go-to-section', 'accountMsgFuncAgreement')"
          >
            メッセージに関する同意事項
          </li>
        </ul>
      </li>
    </ul>

    <ul
      class="fixed pl-6 mb-16 leading-4 text-gray-62"
      v-bind:style="{ bottom: state.bottomMenuPos + 'px' }"
    >
      <li class="mb-6">
        <span class="cursor-pointer" @click="globalMethods.logout()"
          >ログアウト</span
        >
      </li>
    </ul>
  </section>
</template>

<script>
import { reactive, onMounted, inject } from 'vue';

export default {
  props: {
    active: String,
    visibleSection: String,
  },
  emits: ['go-to-section'],
  setup(props) {
    const globalMethods = inject('globalMethods');

    const state = reactive({
      footerPos: '',
      bottomMenuPos: 64,
    });
    const footerH = 64;
    onMounted(() => {
      // FIXME: render時の高さが正確に取得できないので固定値
      if (props.active === 'account') {
        state.bottomMenuPos = footerH;
      } else {
        calcFooterPos();
      }
    });
    window.addEventListener('scroll', calcFooterPos);
    function calcFooterPos() {
      const footerPos = document
        .getElementById('footer')
        .getBoundingClientRect().top;
      const windowH = window.innerHeight;
      state.bottomMenuPos =
        footerPos < windowH - footerH ? windowH - footerPos : footerH;
    }
    return {
      state,
      globalMethods,
    };
  },
};
</script>

<style lang="scss" scoped>
.menu-left-width {
  width: 100%;
  max-width: 240px;
}
@media screen and (min-width: 1280px) {
  .menu-left-width {
    max-width: 280px;
  }
}
</style>
